import DOMPurify from "isomorphic-dompurify"
import type { Config } from "isomorphic-dompurify"

const isBrowser = typeof window !== "undefined" && typeof document !== "undefined"

export const defaultSanitizeOptions: Config = {
  USE_PROFILES: { html: true },
  ALLOWED_TAGS: [
    "p",
    "br",
    "a",
    "strong",
    "em",
    "b",
    "i",
    "u",
    "ul",
    "ol",
    "li",
    "blockquote",
    "code",
    "pre",
    "span"
  ],
  ALLOWED_ATTR: ["href", "title", "target", "rel", "class", "id", "style"]
}

if (isBrowser) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node instanceof Element && node.tagName.toLowerCase() === "a") {
      const target = node.getAttribute("target")
      if (target === "_blank") {
        const rel = node.getAttribute("rel") || ""
        const safeRel = new Set(rel.split(" ").filter(Boolean))
        safeRel.add("noopener")
        safeRel.add("noreferrer")
        node.setAttribute("rel", Array.from(safeRel).join(" "))
      }
    }
  })
}

export function sanitizeHtml(input?: string | null, options?: Config): string {
  if (!input) return ""
  return DOMPurify.sanitize(input, options ?? defaultSanitizeOptions)
}
